import type { IconProps } from './IconLibrary';

function PathRockIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <ellipse cx="13" cy="26" rx="9" ry="6" fill="#b3ada3" stroke="#2f2f2f" strokeWidth="1.5" />
      <path
        d="M20 12 L28 10 L34 15 L31 22 L23 23 L18 18 Z"
        fill="#c9c3b8"
        stroke="#2f2f2f"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PathRockIcon;
